export default __webpack_public_path__ + "static/media/crew-chief-background.7f1dbb9d.webp";